import $ from 'jquery'
import 'slick-carousel'

$(document).ready(function() {
  const $wrapper = $('.testimonials-wrapper')

  if ( ! $wrapper.length ) {
    return
  }

  const options = {
    rtl: document.documentElement.getAttribute('dir') === 'rtl',
    centerMode: true,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader">Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="screen-reader">Next</span></button>',
  }

  const mediaQuery = window.matchMedia('(max-width: 767px)')

  if ( mediaQuery.matches ) {
    window.requestAnimationFrame(function() {
      $wrapper.slick(options)
    })
  }

  mediaQuery.onchange = function(e) {
    if (e.matches) {
      $wrapper.slick(options);
    } else {
      $wrapper.slick('destroy');
    }
  }
})
